import { Spin } from "antd";
import { FC } from "react";

export const SLoading: FC = () => {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
      }}
    >
      <Spin
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    </div>
  );
};
